import groupBy from 'lodash.groupby';
import sortBy from 'lodash.sortby';
import get from 'lodash.get';
import moment from 'moment';
import { FROM_THIS_MONDAY, WEEK_FORMAT_STRING, GRILL_DIET_KEY } from '@/constants';

const getTimeByEvent = (event) => {
  switch (event) {
    case 'breakfast':
      return '09:00:00';
    case 'lunch':
      return '13:00:00';
    default:
      return '00:00:00';
  }
};

const getTotalsByEvent = (event, orders = []) => {
  if (Object.keys(orders).length === 0) return 0;
  const filterByEvent = orders.filter((item) => item.menuInfo.event === event.id);
  return Array.isArray(filterByEvent) ? filterByEvent.length : null;
};

const groupOrdersByPath = (orders, path) => {
  const sortedOrders = sortBy(orders, (order) => get(order, path, null));
  return groupBy(sortedOrders, (order) => get(order, path, null));
};

const getWeekStartAndEndDate = (weekNumber) => {
  const weekDaysAdded = FROM_THIS_MONDAY.toNextWeek * weekNumber;
  const startDate = moment().day(FROM_THIS_MONDAY.toThisMonday + weekDaysAdded);
  const endDate = moment().day(FROM_THIS_MONDAY.toThisFriday + weekDaysAdded);

  return {
    startDate,
    endDate,
  };
};

const parseWeek = (weekParam) => {
  if (moment.isMoment(weekParam)) {
    return moment(weekParam.format(WEEK_FORMAT_STRING), WEEK_FORMAT_STRING);
  }
  return moment(weekParam, WEEK_FORMAT_STRING);
};

const formatWeek = (week) => week.format(WEEK_FORMAT_STRING);

const existsInArray = (value, collection) => collection.indexOf(value) !== -1;

const countOrdersByPredicate = (orders = [], predicate) => {
  if (!orders || orders.length === 0) return null;
  const count = orders.filter(predicate).length;
  return count > 0 ? count : null;
};

const isGrillOrder = (o) =>
  o.mealInfo &&
  o.mealInfo.dietInfo &&
  o.mealInfo.dietInfo.name &&
  o.mealInfo.dietInfo.name.toLowerCase() === GRILL_DIET_KEY;

const getGrillOptionNames = (orders) =>
  Array.from(
    new Set(
      (orders || [])
        .filter(isGrillOrder)
        .map((o) => o.mealInfo.name)
        .filter(Boolean)
    )
  );

const getGrillOptionCountsPerEvent = (orders, mealEvents, optionName) =>
  mealEvents.map((event) =>
    countOrdersByPredicate(
      orders,
      (o) => o.menuInfo.event === event.id && isGrillOrder(o) && o.mealInfo.name === optionName
    )
  );

const getCombinedGrillCountsPerEvent = (orders, mealEvents) =>
  mealEvents.map((event) =>
    countOrdersByPredicate(orders, (o) => o.menuInfo.event === event.id && isGrillOrder(o))
  );

export {
  getTimeByEvent,
  getTotalsByEvent,
  groupOrdersByPath,
  getWeekStartAndEndDate,
  parseWeek,
  formatWeek,
  existsInArray,
  countOrdersByPredicate,
  getGrillOptionNames,
  getGrillOptionCountsPerEvent,
  getCombinedGrillCountsPerEvent,
};



// WEBPACK FOOTER //
// ./src/helpers/index.js